
export class QuotationCoverageScheduleDO {

	public id: Number = null;

	public policyYear: Number = null;

	public sumInsured: any = null;

	public baseAnnualPremium: any = null;

	public premiumRate: any = null;

	public entryAge: Number = null;

	public productTypeCd: String = null;

	public term: Number = null;

	public commencementDt: String = null;

	public expiryDt: String = null;

	public getId() {
		return this.id;
	}
	public setId(id: Number) {
		this.id = id;
	}
	public getPolicyYear() {
		return this.policyYear;
	}
	public setPolicyYear(policyYear) {
		this.policyYear = policyYear;
	}
	public getSumInsured() {
		return this.sumInsured;
	}
	public setSumInsured(sumInsured) {
		this.sumInsured = sumInsured;
	}
	public getBaseAnnualPremium() {
		return this.baseAnnualPremium;
	}
	public setBaseAnnualPremium(baseAnnualPremium) {
		this.baseAnnualPremium = baseAnnualPremium;
	}
	public getPremiumRate() {
		return this.premiumRate;
	}
	public setPremiumRate(premiumRate) {
		this.premiumRate = premiumRate;
	}
	public getEntryAge() {
		return this.entryAge;
	}
	public setEntryAge(entryAge) {
		this.entryAge = entryAge;
	}
	public getProductTypeCd() {
		return this.productTypeCd;
	}
	public setProductTypeCd(productTypeCd) {
		this.productTypeCd = productTypeCd;
	}
}
